function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { getBreakpointValue, getSize } from '@mantine/styles';
function getSortedKeys(value, theme) {
    var sorted = Object.keys(value).filter(function(breakpoint) {
        return breakpoint !== "base";
    }).sort(function(a, b) {
        return getBreakpointValue(getSize({
            size: a,
            sizes: theme.breakpoints
        })) - getBreakpointValue(getSize({
            size: b,
            sizes: theme.breakpoints
        }));
    });
    return "base" in value ? [
        "base"
    ].concat(_to_consumable_array(sorted)) : sorted;
}
function getResponsiveValue(param) {
    var value = param.value, theme = param.theme, getValue = param.getValue, property = param.property;
    if (value == null) {
        return void 0;
    }
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object") {
        var result = getSortedKeys(value, theme).reduce(function(acc, breakpointKey) {
            if (breakpointKey === "base" && value.base !== void 0) {
                var baseValue = getValue(value.base, theme);
                if (Array.isArray(property)) {
                    property.forEach(function(prop) {
                        acc[prop] = baseValue;
                    });
                    return acc;
                }
                acc[property] = baseValue;
                return acc;
            }
            var breakpointValue = getValue(value[breakpointKey], theme);
            if (Array.isArray(property)) {
                acc[theme.fn.largerThan(breakpointKey)] = {};
                property.forEach(function(prop) {
                    acc[theme.fn.largerThan(breakpointKey)][prop] = breakpointValue;
                });
                return acc;
            }
            acc[theme.fn.largerThan(breakpointKey)] = _define_property({}, property, breakpointValue);
            return acc;
        }, {});
        return result;
    }
    var cssValue = getValue(value, theme);
    if (Array.isArray(property)) {
        return property.reduce(function(acc, prop) {
            acc[prop] = cssValue;
            return acc;
        }, {});
    }
    return _define_property({}, property, cssValue);
}
export { getResponsiveValue }; //# sourceMappingURL=get-responsive-value.js.map
